export abstract class InternalAddressesStrategyService {
    abstract isExternalLink(link:string):boolean;

}
